import { render, staticRenderFns } from "./btn-choose-avatar.mpx?vue&type=template&id=617ab650&isComponent&outputPath=components%2Fbtn-choose-avatar121b01b8%2Findex"
import script from "./btn-choose-avatar.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-choose-avatar121b01b8%2Findex"
export * from "./btn-choose-avatar.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-choose-avatar121b01b8%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports